import { render, staticRenderFns } from "./DataInputCombobox.vue?vue&type=template&id=3c4139f8&scoped=true&"
import script from "./DataInputCombobox.vue?vue&type=script&lang=js&"
export * from "./DataInputCombobox.vue?vue&type=script&lang=js&"
import style0 from "./DataInputCombobox.vue?vue&type=style&index=0&id=3c4139f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4139f8",
  null
  
)

export default component.exports